import { SYSTEM_NAME_AUTH, UserRoles } from "./+app-custom/constants";
import { getBaseFrontendUrl } from "./+app-custom/app.urls";

export const NavigationItems = [
  {
    title: 'modules',
    tags: 'modules',
    icon: 'fal fa-angle-down',
    routerLink: 'null',
    externalUrl: `${getBaseFrontendUrl(SYSTEM_NAME_AUTH)}`,
    roles: UserRoles.All
  },
  {
    title: 'dashboard',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/dashboard',
    roles: UserRoles.All
  },
  {
    title: 'EPC',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/epc',
    roles: UserRoles.All
  },
  {
    title: 'ETD',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/etd',
    roles: [UserRoles.Superadmin]  },
  {
    title: 'ISBN',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/isbn',
    roles: [UserRoles.Superadmin]  },
  {
    title: 'HELPDESK',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/helpdesk',
    roles: [UserRoles.Superadmin]  },
  {
    title: 'ROOMBOOK',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/roombook',
    roles: [UserRoles.Superadmin]  },
  {
    title: 'ZP',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/zp',
    roles: [UserRoles.Superadmin]  },
  {
    title: 'UIK',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/uik',
    roles: [UserRoles.Superadmin]  },
  {
    title: 'originality',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/originality',
    roles: [UserRoles.Superadmin]
  },
  {
    title: 'others',
    tags: 'application intel',
    icon: 'fal fa-info-circle',
    routerLink: '/others',
    roles: [UserRoles.Superadmin]
  },
  {
    title: 'notifications',
    tags: 'application intel',
    icon: 'fal fa-bell',
    routerLink: '/notifications',
    roles: [UserRoles.Superadmin]
  },
  {
    title: 'errorReports',
    tags: 'application intel',
    icon: 'fal fa-bug',
    routerLink: '/error-reports',
    roles: [UserRoles.Superadmin]
  },
];
